<template>
  <div class="flex datep justify-center">
    <div class="flex sm:6/12 picker"
      v-if="selectedOption.id != 3">
      <DatePicker
        @changedyear="monthYearSelected"
        @date-selected="dateSelected"
        :nome="'weekpicker'"
        :date="ndate"
        :small="true"
        :weekpicker="true" />
    </div>
    <div class="flex sm:6/12"
      v-if="selectedOption.id == 3">
      <DatePicker
        :nome="'yearpicker'"
        :date="ndate"
        @changedyear="monthYearSelected"
        @date-selected="monthPickerUpdated"
        :monthpicker="true" />
    </div>
  </div>
</template>

<script>
import { useEventSearch } from "@/stores/eventSearch.ts";
import DatePicker from "@/components/datepicker/datepicker.vue";

export default {
  name: "IpadFormCalendars",
  props: ["currentweek", "selectedOption"],
  components: {
    DatePicker,
  },
  setup(){
    const eventsearch = useEventSearch();
    function updateSelectedWeek(selectedWeek){
      eventsearch.setSelectedWeek(selectedWeek);
    }
    return {
      updateSelectedWeek
    }
  },
  data() {
    return {
      ndate: null,
    };
  },
  mounted() {
    this.ndate = [
      new Date(this.currentweek.start),
      new Date(this.currentweek.end),
    ];
  },
  watch:{
    'currentweek': function(newval){
      this.ndate = [
        new Date(newval.start),
        new Date(newval.end),
      ];
    }
  },
  methods: {
    dateSelected(data) {
      const dates = { start: data[0], end: data[1] };
      this.updateSelectedWeek(dates);
    },
    monthPickerUpdated(data) {
      const { year, month } = data;
      const dates = {
        start: new Date(year, month, 1),
        end: new Date(year, month + 1, 0),
      };
      this.updateSelectedWeek(dates);
    },
    monthYearSelected(data) {
      const { year, month } = data;
      this.ndate = new Date(`${year}-${month + 1}-01`);
    }
  },
};
</script>

<style>
@media only screen and (max-width: 767px) {
  .dropdown-pane.notop#grauDropDown {
    top: 40px;
  }

  .dropdown-pane .drop.nopaddingtop {
    padding-top: 0;
  }
}
</style>

<style scoped>
@tailwind base;
@tailwind components;
@tailwind utilities;

.datep {
  display: none;
}

@media only screen and (max-width: 1024px) {
  .datep {
    display: flex;
    padding-right: 45px;
    padding-left: 45px;
  }
}

@media screen and (max-width: 1024px) {
  .datep {
    padding-right: 10px;
    padding-left: 10px;
    margin-right: 0;
    margin-left: 0;
  }
}
</style>
